"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _pickup = require("@/api/pickup");
var _vuePropertyDecorator = require("vue-property-decorator");
var _address = require("@/api/address");
var _ghn = require("@/api/ghn");
var AddressModal = /*#__PURE__*/function (_Vue) {
  function AddressModal() {
    var _this;
    (0, _classCallCheck2.default)(this, AddressModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, AddressModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "type", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      phone: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      email: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      address: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      addressCityId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      addressDistrictId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      addressWardId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      wardCode: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      districtId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      },
      cityId: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "cities", []);
    (0, _defineProperty2.default)(_this, "districts", []);
    (0, _defineProperty2.default)(_this, "wards", []);
    return _this;
  }
  (0, _inherits2.default)(AddressModal, _Vue);
  return (0, _createClass2.default)(AddressModal, [{
    key: "created",
    value: function created() {
      if (this.type == "GHTK") {
        this.fetchCities();
      } else {
        this.fetchGHNCities();
      }
    }
  }, {
    key: "watchCity",
    value: function watchCity(val) {
      console.log("val", val);
      if (!val) {
        return;
      }
      this.fetchDistricts();
    }
  }, {
    key: "watchDistrictId",
    value: function watchDistrictId() {
      this.fetchWards();
    }
  }, {
    key: "watchCityGHN",
    value: function watchCityGHN(val) {
      if (!val) {
        return;
      }
      this.fetchGHNDistricts();
    }
  }, {
    key: "watchDistrictGHN",
    value: function watchDistrictGHN() {
      this.fetchGHNWards();
    }
  }, {
    key: "fetchCities",
    value: function () {
      var _fetchCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _address.addressApi.findCity();
            case 2:
              res = _context.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchCities() {
        return _fetchCities.apply(this, arguments);
      }
      return fetchCities;
    }()
  }, {
    key: "fetchDistricts",
    value: function () {
      var _fetchDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _this2 = this;
        var city, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              city = this.cities.find(function (e) {
                return e.id == _this2.form.addressCityId;
              });
              _context2.next = 3;
              return _address.addressApi.findDistrict({
                parentCode: city.code
              });
            case 3:
              res = _context2.sent;
              this.districts = res.data.data;
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchDistricts() {
        return _fetchDistricts.apply(this, arguments);
      }
      return fetchDistricts;
    }()
  }, {
    key: "fetchWards",
    value: function () {
      var _fetchWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _this3 = this;
        var district, res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              district = this.districts.find(function (e) {
                return e.id == _this3.form.addressDistrictId;
              });
              if (district) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return _address.addressApi.findWard({
                parentCode: district.code
              });
            case 5:
              res = _context3.sent;
              this.wards = res.data.data;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchWards() {
        return _fetchWards.apply(this, arguments);
      }
      return fetchWards;
    }()
  }, {
    key: "handleChangeDistrict",
    value: function handleChangeDistrict() {
      this.form.addressWardId = null;
    }
  }, {
    key: "handleChangeCity",
    value: function handleChangeCity() {
      this.$set(this.form, "addressDistrictId", null);
      this.$set(this.form, "addressWardId", null);
    }
  }, {
    key: "fetchGHNDistricts",
    value: function () {
      var _fetchGHNDistricts = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _ghn.ghnApi.findDistrict({
                province_id: this.form.cityId
              });
            case 2:
              res = _context4.sent;
              this.districts = res.data.data;
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchGHNDistricts() {
        return _fetchGHNDistricts.apply(this, arguments);
      }
      return fetchGHNDistricts;
    }()
  }, {
    key: "fetchGHNCities",
    value: function () {
      var _fetchGHNCities = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _ghn.ghnApi.findCity();
            case 2:
              res = _context5.sent;
              this.cities = res.data.data;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function fetchGHNCities() {
        return _fetchGHNCities.apply(this, arguments);
      }
      return fetchGHNCities;
    }()
  }, {
    key: "fetchGHNWards",
    value: function () {
      var _fetchGHNWards = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _ghn.ghnApi.findWard({
                district_id: this.form.districtId
              });
            case 2:
              res = _context6.sent;
              this.wards = res.data.data;
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function fetchGHNWards() {
        return _fetchGHNWards.apply(this, arguments);
      }
      return fetchGHNWards;
    }()
  }, {
    key: "handleChangeGHNDistrict",
    value: function handleChangeGHNDistrict() {
      this.form.wardCode = null;
    }
  }, {
    key: "handleChangeGHNCity",
    value: function handleChangeGHNCity() {
      this.$set(this.form, "districtId", null);
      this.$set(this.form, "wardCode", null);
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return this.$confirm("Confirm delete this address?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingSubmit = true;
              _context7.next = 6;
              return _pickup.pickUpApi.remove(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete address",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context7.prev = 9;
              this.loadingSubmit = false;
              return _context7.finish(9);
            case 12:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee8() {
        var _this4 = this;
        var valid, city, district, ward, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context8.sent;
              if (!valid) {
                _context8.next = 18;
                break;
              }
              _context8.prev = 4;
              this.loadingSubmit = true;
              city = this.cities.find(function (e) {
                return e.ProvinceID == _this4.form.cityId;
              });
              district = this.districts.find(function (e) {
                return e.DistrictID == _this4.form.districtId;
              });
              ward = this.wards.find(function (e) {
                return e.WardCode == _this4.form.wardCode;
              });
              data = {
                pickUp: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                  type: this.type,
                  cityName: city && city.ProvinceName,
                  cityCode: city && city.Code,
                  districtName: district && district.DistrictName,
                  districtCode: district && district.Code,
                  wardName: ward && ward.WardName
                }),
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId
              };
              _context8.next = 12;
              return _pickup.pickUpApi.create(data);
            case 12:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 15:
              _context8.prev = 15;
              this.loadingSubmit = false;
              return _context8.finish(15);
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this, [[4,, 15, 18]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee9() {
        var _this5 = this;
        var city, district, ward, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              this.loadingSubmit = true;
              city = this.cities.find(function (e) {
                return e.ProvinceID == _this5.form.cityId;
              });
              district = this.districts.find(function (e) {
                return e.DistrictID == _this5.form.districtId;
              });
              ward = this.wards.find(function (e) {
                return e.WardCode == _this5.form.wardCode;
              });
              data = {
                pickUp: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), {}, {
                  type: this.type,
                  cityName: city && city.ProvinceName,
                  cityCode: city && city.Code,
                  districtName: district && district.DistrictName,
                  districtCode: district && district.Code,
                  wardName: ward && ward.WardName
                }),
                addressCityId: this.form.addressCityId,
                addressDistrictId: this.form.addressDistrictId,
                addressWardId: this.form.addressWardId
              };
              _context9.next = 8;
              return _pickup.pickUpApi.update(this.form.id, data);
            case 8:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 11:
              _context9.prev = 11;
              this.loadingSubmit = false;
              return _context9.finish(11);
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[0,, 11, 14]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function () {
      var _handleCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee10() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              this.visible = true;
              this.status = "create";
              this.form = {};
              _context10.next = 5;
              return this.$nextTick();
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handleCreate() {
        return _handleCreate.apply(this, arguments);
      }
      return handleCreate;
    }()
  }, {
    key: "handleUpdate",
    value: function () {
      var _handleUpdate = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee11(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.visible = true;
              this.status = "update";
              this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                cityId: +data.cityId,
                districtId: +data.districtId,
                addressCityId: data.addressCity && data.type == "GHTK" && data.addressCity.id,
                addressDistrictId: data.addressDistrict && data.type == "GHTK" && data.addressDistrict.id,
                addressWardId: data.addressWard && data.type == "GHTK" && data.addressWard.id
              });
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function handleUpdate(_x) {
        return _handleUpdate.apply(this, arguments);
      }
      return handleUpdate;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], AddressModal.prototype, "type", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.addressCityId", {
  deep: true,
  immediate: true
})], AddressModal.prototype, "watchCity", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.addressDistrictId", {
  deep: true,
  immediate: true
})], AddressModal.prototype, "watchDistrictId", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.cityId", {
  deep: true,
  immediate: true
})], AddressModal.prototype, "watchCityGHN", null);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("form.districtId", {
  deep: true,
  immediate: true
})], AddressModal.prototype, "watchDistrictGHN", null);
AddressModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {}
})], AddressModal);
var _default = exports.default = AddressModal;